import type {
  RequiredAccess,
  RequiredAccessTool,
  RequiredAccessType
} from "./required-access.types"

export const REQUIRED_ACCESS_TYPES: RequiredAccessType[] = [
  "network",
  "file-system",
  "execution"
]

// Demo-level granularity: which access types a tool needs, derived from its
// data categories with the tool name as a fallback.
const CATEGORIES: Record<RequiredAccessType, string[]> = {
  network: [
    "external_api_web",
    "web_and_internet",
    "communication",
    "business_saas",
    "cloud_and_infrastructure",
    "ai_and_agents"
  ],
  "file-system": ["data_write", "files_and_storage", "code_and_development"],
  execution: ["code_and_command_execution"]
}

const NAME_HINTS: Record<RequiredAccessType, RegExp> = {
  network: /\b(fetch|web|search|https?|api|slack|github|jira|nvd|notify)\b/i,
  "file-system":
    /\b(files?|read|write|git|patch|logs?|lint|build|docs?|tail)\b/i,
  execution: /\b(run|tests?|exec|remediation|scale|terminate|apply)\b/i
}

const needs = (tool: RequiredAccessTool, type: RequiredAccessType) =>
  tool.dataCategory.some((category) => CATEGORIES[type].includes(category)) ||
  NAME_HINTS[type].test(tool.name)

export const getRequiredAccess = (
  tool: RequiredAccessTool
): RequiredAccess => ({
  network: needs(tool, "network"),
  "file-system": needs(tool, "file-system"),
  execution: needs(tool, "execution")
})
